export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
export const ROLE_LABEL = { super_admin: 'Super Admin', gestor: 'Gestor', chefe_equipa: 'Chefe de Equipa', backoffice: 'Backoffice', comercial: 'Comercial', admin: 'Admin' };
export const fmtTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const today = new Date().toDateString() === d.toDateString();
  return today ? d.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' }) : d.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' }) + ' ' + d.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
};
export const fileUrl = (id) => `${API_URL}/files/${id}/download?auth=${encodeURIComponent(localStorage.getItem('token') || '')}`;
